import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "stores/Stores";
import styles from "./motivationCard.module.scss";
import { ComponentEventHandler, Flex, MenuProps } from "@fluentui/react-northstar";
import Tabs from "tabs/Tabs";
import { constants } from "shared/constants";
import { BusinessRole } from "shared/enums/BusinessRole";
import { Tab } from "shared/models/Tab";
import { MotivationCardTab } from "./MotivationCardTab";
import pages from "shared/routing/pages";
import { useNavigate } from "react-router-dom";
import EmptyContent from "view360Card/components/emptyContent/EmptyContent";
import pl from "shared/messages/pl";
import { RankingV3ReportFilter_PublicPeriod } from "shared/service/api/generated";
import RankingPage from "./tabs/salesRanking/RankingPage";

export interface MotivationCardProps {
    activeTab?: number;
}

const MotivationCard: React.FC<MotivationCardProps> = observer((props) => {
    const { authorizationStore } = useStore();
    const [activeTab, setActiveTab] = useState<number>();
    const navigation = useNavigate();

    useEffect(() => {
        if (props.activeTab === undefined) {
            return;
        }

        const expectedTab = constants.motivationCardTabs.find((c) => c.key === props.activeTab!);
        if (!expectedTab) {
            return;
        }

        const availableCards = getAvailableCards();

        const index = availableCards.findIndex((c) => c.key === props.activeTab!);
        if (index >= 0) {
            setActiveTab(index);
        }
    }, [props.activeTab]);

    const getAvailableCards = (): Tab[] => {
        let availableTabs = constants.motivationCardTabs;
        let unavailabeTabKeys: number[] = [];

        if (authorizationStore.currentUser?.businessRole === BusinessRole.HQ) {
            unavailabeTabKeys.push(MotivationCardTab.SALESRANK_MONTHLY);
            unavailabeTabKeys.push(MotivationCardTab.SALESRANK_QUARTERLY);
        }

        if (authorizationStore.currentUser?.businessRole === BusinessRole.MS) {
            unavailabeTabKeys.push(MotivationCardTab.SALESRANK_QUARTERLY);
        }

        return availableTabs.filter((tab) => unavailabeTabKeys.indexOf(tab.key) < 0);
    };

    const handleOnActiveIndexChange: ComponentEventHandler<MenuProps> = (_, data) => {
        const index = Number(data?.activeIndex ?? 0);
        const currentTab = getAvailableCards()[index];
        let navigateTo = pages.motivationMonthly.path;
        switch (currentTab.key) {
            case MotivationCardTab.SALESRANK_QUARTERLY:
                navigateTo = pages.motivationQuarterly.path;
                break;
            default:
                break;
        }
        navigation(navigateTo);
    };

    if (activeTab === undefined) {
        return <EmptyContent message={pl.common.noData} graphic="welcome" />;
    }

    return (
        <Flex>
            <div className={styles.reportsWrapper} style={{ width: "100%" }}>
                <Tabs
                    additionalClassName={styles.tabs}
                    activeTab={activeTab}
                    items={getAvailableCards()}
                    onActiveIndexChange={handleOnActiveIndexChange}
                />

                {(activeTab === MotivationCardTab.SALESRANK_MONTHLY ||
                    activeTab === MotivationCardTab.SALESRANK_QUARTERLY) && (
                    <RankingPage
                        period={
                            activeTab === MotivationCardTab.SALESRANK_MONTHLY
                                ? RankingV3ReportFilter_PublicPeriod.MONTHLY
                                : RankingV3ReportFilter_PublicPeriod.QUARTERLY
                        }
                    />
                )}
            </div>
        </Flex>
    );
});

export default MotivationCard;
